import {ProductStockStatus, CheckoutRedemption} from "@irati/types"

export default function isStockAssignmentError(redemption: CheckoutRedemption) {
  let failed = false
  if (redemption.order?.products) {
    redemption.order.products.forEach((product) => {
      if (product.items) {
        product.items.forEach((item) => {
          if (item?.status === ProductStockStatus.Failed) {
            failed = true
          }
        })
      }
    })
  }

  return failed
}
